import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { TRACKS, CATALOG } from './data/catalog';
import CategorySelection from './CategorySelection.jsx';
import TopicSelection from './TopicSelection.jsx';
import Workspace from './Workspace.jsx';

/** Given a catalog and an itemId, find which categoryId it belongs to,
 *  whether it's a topic-level or problem-level item. */
function resolveItemFromCatalog(itemId) {
    for (const [categoryId, categoryData] of Object.entries(CATALOG)) {
        for (const topic of (categoryData.topics || [])) {
            if (topic.id === itemId) {
                return { categoryId, topicId: itemId, problemId: '' };
            }
            for (const problem of (topic.problems || [])) {
                if (problem.id === itemId) {
                    return { categoryId, topicId: '', problemId: itemId };
                }
            }
        }
    }
    return null;
}

export const FlowstateDynamicRouter = () => {
    const params = useParams();
    // React Router v6 puts wildcard matches into the '*' key.
    const fullPath = params["*"];

    if (!fullPath) {
        return <Navigate to="/interview-prep" replace />;
    }

    const segments = fullPath.split('/').filter(Boolean);
    const lastSegment = segments[segments.length - 1];

    // ── Greedy Resolution Logic ──
    // We look at segments to find the most specific valid ID.
    // Order of specificity: Item (Topic/Problem) > Category > Track
    
    // Check if the terminal segment is a Topic or Problem
    const resolvedItem = resolveItemFromCatalog(lastSegment);
    if (resolvedItem && Workspace) {
        return (
            <Workspace
                injectedCategoryId={resolvedItem.categoryId}
                injectedTopicId={resolvedItem.topicId}
                injectedProblemId={resolvedItem.problemId}
            />
        );
    }

    // Check if the terminal segment is a Category
    if (CATALOG[lastSegment] && TopicSelection) {
        return <TopicSelection injectedCategoryId={lastSegment} />;
    }

    // Check if the terminal segment is a Track
    if (TRACKS[lastSegment] && CategorySelection) {
        return <CategorySelection injectedTrackId={lastSegment} />;
    }

    // Legacy Fallback (keeping it safe)
    if (segments.includes('topic') || segments.includes('problem') || segments.includes('track')) {
        // ... (existing legacy logic if needed, but the greedy logic above should catch clean versions)
    }

    // Catch-all: If nothing matches, redirect home
    return <Navigate to="/interview-prep" replace />;
};

